// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Routes, Route, BrowserRouter } from 'react-router-dom';

// -------------------------------------------------------------------------------
// Store
// -------------------------------------------------------------------------------
import { store } from './store/store';

// -------------------------------------------------------------------------------
// Components
// -------------------------------------------------------------------------------
import { HomePage } from './pages/home-page';

// -------------------------------------------------------------------------------
// Styles
// -------------------------------------------------------------------------------
import { Theme } from './theme';
import './theme/styles/styles.scss';

// -------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------
const container = document.getElementById('root');
const root = createRoot(container);

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Provider store={store}>
              <Theme>
                <HomePage />
              </Theme>
            </Provider>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
